module.exports = __webpack_public_path__ + "static/aplicativeiLogo-1f7a677f539133511848104b962732a2.svg";